module.exports = __webpack_public_path__ + "img/860x750px-Terko.80787ff2.jpg";